module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 40
// module chunks = 0